import ReportController from './report.controller';

export default class InternationalReportController extends ReportController
{
	get endpoint() {
		return 'international';
	}

	get title() {
		return 'International Pax Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/international.report.controller.js
 **/